import Vue from 'vue'
import Router from 'vue-router'
//import {HomeComponent} from 'dync-web'
import HomeComponent from '../views/Home.vue'
Vue.use(Router)

export default new Router({
  routes: [
    
    {
      path: '/',
      name: 'root',
      redirect: { name: 'home' }
    },
    {
      path: '/home',
      name: 'home',
      props: {
        order: []
      },
      meta: {
        icon: 'mdi-home',
        displayname: 'Home view'
      },
      component: HomeComponent
    }
  ]
})
